import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';

import { Field, ErrorMessage } from "formik";
import { CurrentTheme } from "common";
import MagstimInputGroup from './MagstimInputGroup'

const AUTO_COMPLETE_OFF = 'off';

class MagstimInputGroupRMT extends MagstimInputGroup {

    onCheckboxChange = () => {
        const newCheckState = !this.state.checked;
        this.setState({ checked: newCheckState, disabled: !newCheckState })

        if (this.props.onSetEnabled !== undefined) {
            this.props.onSetEnabled(this.props.name, newCheckState, this.props.validateForm);
        }
    }

    render() {

        // const placeholder = this.props.title.replace('*', '')

        var titleClassName = "input-group-highlight"

        if(this.state.disabled === true){
            titleClassName = "input-group-disabled"
        }

        return (
            <Wrapper>
                <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                    <InputGroupText  className={titleClassName}>{this.props.title}</InputGroupText>
                </InputGroupAddon>

                <InputGroup size={CurrentTheme().ControlSize}>
                    <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                        <InputGroupText  className={titleClassName}>{this.props.title}</InputGroupText>
                    </InputGroupAddon>

                    <InputGroupAddon addonType="append" className="magstim-checkbox-container mr-3">
                        <Input type="checkbox" className="magstim-checkbox" checked={this.state.checked} onChange={this.onCheckboxChange} />
                    </InputGroupAddon>

                    <div className="input-div">
                        <Input type="number"
                            disabled={this.state.disabled}
                            autoComplete={AUTO_COMPLETE_OFF}
                            onFocus={this.onFocus}
                            name="RMTMin"
                            placeholder="Min"
                            tag={Field}
                            className={`form-control ${this.props.touched.RMTMin && this.props.errors.RMTMin ? "is-invalid" : ""}`} />

                        <ErrorMessage component="div" name="RMTMin" className="invalid-feedback" />
                    </div>

                    <div className="input-space" />

                    <div className="input-div">
                        <Input type="number"
                            disabled={this.state.disabled}
                            autoComplete={AUTO_COMPLETE_OFF}
                            onFocus={this.onFocus}
                            name="RMTMax"
                            placeholder="Max"
                            tag={Field}
                            className={`form-control ${this.props.touched.RMTMax && this.props.errors.RMTMax ? "is-invalid" : ""}`} />

                        <ErrorMessage component="div" name="RMTMax" className="invalid-feedback" />
                    </div>

                </InputGroup>
            </Wrapper>
        );
    }
}

MagstimInputGroupRMT.propTypes = {
    title: PropTypes.string,
    name: PropTypes.string,
    touched: PropTypes.object,
    errors: PropTypes.object,
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    onSetEnabled: PropTypes.func,
    validateForm: PropTypes.func,
};

MagstimInputGroupRMT.defaultProps = {
    title: "",
    name: "",
    touched: false,
    errors: undefined,
    disabled: false,
    checked: undefined,
    onSetEnabled: undefined,
    validateForm: undefined
};

const Wrapper = styled.div`

.input-space{
    width:10px;
}

.input-div{
    flex: 1 1 auto;
}

@media only screen and (max-width: 520px) {
    .input-space {
      padding-bottom: 50px; /* add more padding when the controls wrap */
    }
}

`

export default MagstimInputGroupRMT